<template>
  <v-col id="imprint">
    <h1>Impressum</h1>

    <h2>Angaben gemäß § 5 DDG</h2>
    <p>
      {{ company.name }}<br>
      {{ company.address1 }}<br>
      {{ company.address2 }}
    </p>

    <h2>Vertretungsberechtigte Person</h2>
    <p>
      {{ ownerFullName }}
    </p>

    <h2>Kontakt</h2>
    <p>
      Telefon: {{ company.phone }}<br>
      E-Mail: <a :href="`mailto:${company.mailFrom}`">{{ company.mailFrom }}</a>
    </p>

    <h2>Verbraucherstreitbeilegung</h2>
    <p>
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <h2>Verantwortung für Unternehmensprofile</h2>
    <p>
      Die auf der Plattform gelisteten Unternehmen sind für die Richtigkeit ihrer
      Unternehmensangaben, Preise, Leistungsbeschreibungen und sonstigen veröffentlichten
      Inhalte selbst verantwortlich.
    </p>
  </v-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'LegalImprint',
  computed: {
    ...mapGetters(['company']),
    ownerFullName() {
      return [
        this.company.ownerTitle,
        this.company.ownerFirstName,
        this.company.ownerLastName
      ].filter(Boolean).join(' ')
    }
  }
}
</script>
